import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const ipv6FilterOperators = unreadonly([
  ...filterOperators.ip,
  ...filterOperators.cidr,
  ...filterOperators.empty,
  ...filterOperators.regexCaseSensitive,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type Ipv6FilterOperator = (typeof ipv6FilterOperators)[number];

export type Ipv6TableFilter = TableFilterBase & {
  type: 'ipv6';
};

export const createIpv6Filter = (): Ipv6TableFilter => ({
  type: 'ipv6',
  operators: ipv6FilterOperators,
});
